import { instance } from 'utils/api';

// v2 wire is the camelCase Patient entity row (legacy GQL was snake_case).
export type PatientRow = {
  id: number;
  avatar?: string | null;
  firstName: string;
  lastName: string;
  dateOfBirth?: string | null;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  languages?: Record<string, any> | null;
  gender?: string | null;
  healthInfo?: Record<string, unknown> | null;
};

// GET /patients — v2 returns a raw [rows, total] TUPLE, not the Paginated
// envelope (flag-back #11). Param is `search` (legacy GQL used `name`).
export const fetchPatients = async (params: {
  page?: number;
  limit?: number;
  search?: string;
}): Promise<{ results: PatientRow[]; total: number }> => {
  const res = await instance.get<[PatientRow[], number]>('patients', {
    params
  });

  const [results, total] = res.data;

  return { results, total };
};

// GET /patients/:id — patient row plus their appointments with this doctor.
export const fetchPatientById = async (
  id: number | string
): Promise<PatientRow & { appointments?: unknown[] }> => {
  const res = await instance.get<PatientRow & { appointments?: unknown[] }>(
    `patients/${id}`
  );

  return res.data;
};
